import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { headerExtraRewards as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
    viewAllLanguage: 'View all stores',
    getTitle: (earnType) => `Stores offering extra ${earnType}`,
    shouldUseFlipTile: true,
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
